import * as React from 'react'
import classNames from 'classnames'
import './reveal.scss'

interface RevealProps {
    open: boolean
    className?: string
    children: React.ReactNode
}

export function Reveal({ open, className, children }: RevealProps) {
    return (
        <div className={classNames('reveal', { open }, className)} aria-hidden={!open}>
            <div className="reveal-inner">{children}</div>
        </div>
    )
}
